<script>
import Vue from 'vue';
import {mapState, mapActions, mapGetters} from 'vuex';
import {required} from "../../services/ValidatorService";

export default Vue.extend({
    computed: {
        ...mapState({
            user: state => state.account.user.user,
            originalUser: state => state.account.user.originalUser
        }),
        ...mapGetters({
            userHasChanged: 'account/userHasChanged'
        }),
        firstNameClasses() {
            return {
                'account-form__input--error': this.$v.user.firstName.$dirty && this.$v.user.firstName.$error,
                'account-form__input--success': this.$v.user.firstName.$dirty && !this.$v.user.firstName.$error
            }
        },
        lastNameClasses() {
            return {
                'account-form__input--error': this.$v.user.lastName.$dirty && this.$v.user.lastName.$error,
                'account-form__input--success': this.$v.user.lastName.$dirty && !this.$v.user.lastName.$error
            }
        }
    },
    methods: {
        ...mapActions({
            editUser: 'account/editUser',
            updateUser: 'account/updateUser',
            resetUser: 'account/resetUser'
        }),
        edit(obj) {
            this.$v.$touch();
            this.editUser(obj);
        }
    },
    validations() {
        return {
            user: {
                firstName: {
                    required: (firstName) => {
                        return required(firstName, 'First name').valid;
                    }
                },
                lastName: {
                    required: (lastName) => {
                        return required(lastName, 'Last name').valid;
                    }
                }
            }
        }
    },
});
</script>

<template>
    <div class="account-form">
        <div class="account-form__heading">
            <div class="account-form__header">
                {{ $t('account.form.heading.header') }}
            </div>
        </div>
        <div class="account-form__inputs">
            <div class="account-form__input-field">
                <label for="account-form__id">{{ $t('account.form.id') }}:</label>
                <input id="account-form__id"
                       :value="user.id" :disabled="true"
                       class="account-form__input"
                       type="text">
            </div>

            <div class="account-form__input-field">
                <label for="account-form__userType">{{ $t('account.form.accountType.label') }}:</label>
                <input id="account-form__userType"
                       :value="$t('account.form.accountType.admin.' + user.admin)"
                       :disabled="true" class="account-form__input"
                       type="text">
            </div>

            <div class="account-form__input-field">
                <label for="account-form__firstName">{{ $t('account.form.firstName') }}:</label>
                <input id="account-form__firstName"
                       :class="firstNameClasses"
                       :placeholder="$t('account.form.placeholder.firstName')"
                       :value="user.firstName"
                       class="account-form__input" type="text"
                       @input="edit({firstName: $event.target.value})">
                <transition name="fade" mode="out-in">
                    <div v-if="$v.user.firstName.$error" class="account-form__error">*{{ $t('account.form.validator.required') }}</div>
                </transition>
            </div>

            <div class="account-form__input-field">
                <label for="account-form__lastName">{{ $t('account.form.lastName') }}:</label>
                <input id="account-form__lastName"
                       :class="lastNameClasses"
                       :placeholder="$t('account.form.placeholder.lastName')"
                       :value="user.lastName"
                       class="account-form__input" type="text"
                       @input="edit({lastName: $event.target.value})">
                <transition name="fade" mode="out-in">
                    <div v-if="$v.user.lastName.$error" class="account-form__error">*{{ $t('account.form.validator.required') }}</div>
                </transition>
            </div>
        </div>
        <div class="account-form__buttons">
            <div class="account-form__button-group">
                <button :disabled="!userHasChanged || $v.$error" class="account-form__btn account-form__btn-update" @click="updateUser()">
                    {{ $t('account.form.buttons.update') }}
                </button>
                <button :disabled="!userHasChanged" class="account-form__btn account-form__btn-reset" @click="resetUser()">
                    {{ $t('account.form.buttons.reset') }}
                </button>
            </div>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/AccountForm/AccountForm.vue